globalThis.Menu = class Menu {
  constructor() {
    this.abort = new AbortController();
    this.div = document.createElement("div");
    this.div.id = "menu";
    this.buttons = {};
    this.constructButton("New", this.onNew.bind(this));
    this.constructButton("Save", this.onSave.bind(this));
    this.constructButton("Save As...", this.onSaveAs.bind(this));
    this.constructButton("Open...", this.onOpen.bind(this));
    this.div.append(document.createElement("div"));
    this.constructButton("Change Size...", this.onSize.bind(this), this.abort);
    this.constructButton("Clear", this.onClear.bind(this), this.abort);
    this.div.append(document.createElement("div"));
    this.constructButton("Exit", this.onExit.bind(this), this.abort);
    this.div.addEventListener("mousedown", cancelbubble, this.abort);
    addEventListener("mousedown", this.deactivate.bind(this), this.abort);
    addEventListener("addcontrol", this.onControl.bind(this), this.abort);
    addEventListener("removecontrol", this.onControl.bind(this), this.abort);
    addEventListener("store", this.update.bind(this), this.abort);
    this.hide();
    document.body.append(this.div);
    this.update();
  }

  constructButton(label, action) {
    const id = label.toLowerCase().replaceAll(/[ .]/g, "");
    const button = document.createElement("button");
    button.innerText = label;
    button.addEventListener(
      "click",
      () => {
        this.deactivate();
        if (action) action();
      },
      this.abort,
    );
    this.div.append((this.buttons[id] = button));
  }

  update() {
    const { saves } = globalThis.STORE;
    const { context } = globalThis.GAME;
    this.buttons.save.disabled = !globalThis.GAME.id || context !== "local";
    this.buttons.open.disabled = !!saves.length;
  }

  onControl(event) {
    if (event.detail !== "menu") return;
    if (this.isActive()) this.show();
    else this.hide();
  }

  onNew() {
    globalThis.ROUTER.goto("/local/");
  }

  onClear() {
    globalThis.CLIENT.clearWorld();
  }

  onSave() {
    globalThis.STORE.saveWorld();
  }

  onSaveAs() {
    new SaveForm();
  }

  onOpen() {
    new ListDialogue({
      title: "Open Save",
      options: Object.keys(globalThis.STORE.saves),
      action() {
        if (!this.selected) return true;
        if (globalThis.GAME.context === "local")
          globalThis.ROUTER.goto(`/local/${this.selected}`);
        else globalThis.STORE.loadWorldFromSave(this.selected);
      },
    });
  }

  onSize() {
    new ListDialogue({
      title: "Change World Size",
      options: globalThis.WORLD_SIZES,
      action() {
        if (!this.selected) return true;
        const { x, y } = Vector2.fromString(this.selected);
        globalThis.CLIENT.setWorldSize(x, y);
      },
    });
  }

  onExit() {
    globalThis.ROUTER.goto("/");
  }

  isActive() {
    return globalThis.TOPBAR.hasControl("menu");
  }

  deactivate() {
    globalThis.TOPBAR.removeControl("menu");
  }

  remove() {
    this.abort.abort();
    this.div.remove();
  }

  hide() {
    this.div.style.display = "none";
  }

  show() {
    this.div.style.display = "";
  }
};
